<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
</script>

<template>
    <InformationBaseCard :label="$t('deviceConfig.templateKeys.title.editKey')">
        <slot />
    </InformationBaseCard>
</template>
